import {
  CASE_ADD_REQUEST,
  CASE_ADD_SUCCESS,
  CASE_ADD_FAILURE,
  CASE_UPDATE_SUCCESS,
  CASE_UPDATE_FAILURE,
  CASE_UPDATE_REQUEST,
  CASE_LEAVE_REQUEST,
  CASE_LEAVE_SUCCESS,
  CASE_LEAVE_FAILURE,
  RESET_CASE_STATE,
  RESET_CASE_STATUS,
  CASE_INFO,
  CASE_CANCEL_AIRFORCE_READINESS_REQUEST,
  CASE_CANCEL_AIRFORCE_READINESS_SUCCESS,
  CASE_CANCEL_AIRFORCE_READINESS_FAILURE,
  RESET_MFA_TOKEN_REQUEST,
  RESET_MFA_TOKEN_SUCCESS,
  RESET_MFA_TOKEN_FAILURE,
  CASE_SEARCH_REQUEST,
  CASE_SEARCH_SUCCESS,
  CASE_SEARCH_FAILURE,
} from '../../actions/actionTypes';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

const INITIAL_STATE = {
  errorMessage: '',
  status: PENDING,
  statusSearch: PENDING,
  mfaResetStatus: PENDING,
  mfaErrorMessage: null,
  caseInfoCaseId: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_MFA_TOKEN_REQUEST:
      return { ...state, mfaResetStatus: REQUESTING, mfaErrorMessage: null };
    case CASE_ADD_REQUEST:
    case CASE_UPDATE_REQUEST:
    case CASE_CANCEL_AIRFORCE_READINESS_REQUEST:
      return { ...state, status: REQUESTING, errorMessage: '' };
    case CASE_SEARCH_REQUEST:
      return { ...state, statusSearch: REQUESTING, errorMessage: '' };
    case RESET_MFA_TOKEN_SUCCESS:
      return { ...state, mfaResetStatus: SUCCESS, mfaErrorMessage: null };
    case CASE_ADD_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        errorMessage: '',
        caseInfoCaseId: action.payload.caseId,
      };
    case CASE_UPDATE_SUCCESS:
    case CASE_CANCEL_AIRFORCE_READINESS_SUCCESS:
      return { ...state, status: SUCCESS, errorMessage: '' };
    case CASE_SEARCH_SUCCESS:
      return { ...state, statusSearch: SUCCESS, errorMessage: '' };
    case RESET_MFA_TOKEN_FAILURE:
      return { ...state, mfaResetStatus: FAILED, mfaErrorMessage: action.payload };
    case CASE_ADD_FAILURE:
    case CASE_UPDATE_FAILURE:
    case CASE_CANCEL_AIRFORCE_READINESS_FAILURE:
      return { ...state, status: FAILED, errorMessage: action.payload };
    case CASE_SEARCH_FAILURE:
      return { ...state, statusSearch: FAILED, errorMessage: action.payload };
    case CASE_LEAVE_REQUEST:
      return { ...state, status: REQUESTING, errorMessage: '' };
    case CASE_LEAVE_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        errorMessage: '',
        caseInfoCaseId: null,
      };
    case CASE_LEAVE_FAILURE:
      return { ...state, status: FAILED, errorMessage: action.payload };
    case CASE_INFO:
      return { ...state, caseInfoCaseId: action.payload };
    case RESET_CASE_STATE:
      return {
        ...INITIAL_STATE,
      };
    case RESET_CASE_STATUS:
      return {
        ...state,
        status: PENDING,
        errorMessage: '',
      };
    default:
      return state;
  }

  return state;
}
